import { useLocation } from 'react-router-dom'
import { LocationState } from '../typings/LocationState'

export function useLocationState(): LocationState {
  const location = useLocation()
  return (location.state as LocationState) || {}
}
